module.exports = __webpack_public_path__ + "static/media/cloudy.d03c3e52.svg";